import { useEffect, useState } from 'react';

import { ConstraintClient } from './api/constraint-client';
import { Constraint } from './constraint';

declare global {
    interface WindowEventMap {
        'useConstraint:request': CustomEvent<string>;
    }
}

const REQUEST_ACCOUNT_EVENT = 'useConstraint:request';
const STORAGE_KEY = 'CSTRS_REQ';

export function constraintRequest(constraintId: string) {
    window.dispatchEvent(new CustomEvent(REQUEST_ACCOUNT_EVENT, { detail: constraintId }));
}

interface Props {
    seedStore: (constraints: Constraint[]) => void;
}

export function useConstraints(props: Props) {
    const [pending, changePending] = useState<string[]>([]);
    const [timeoutSet, changeTimeoutSet] = useState<boolean>(false);
    const [timeoutFinished, changeTimeoutFinished] = useState<boolean>(false);

    useEffect(() => {
        window.addEventListener(REQUEST_ACCOUNT_EVENT, listener);
    }, []);

    useEffect(() => {
        if (timeoutFinished) {
            const stored = localStorage.getItem(STORAGE_KEY);
            if (stored != null) {
                changePending(JSON.parse(stored));
                changeTimeoutSet(false);
                changeTimeoutFinished(false);
                localStorage.removeItem(STORAGE_KEY);
            }
        }
    }, [timeoutFinished]);

    useEffect(() => {
        if (pending.length > 0) {
            getConstraints(pending).then((result) => {
                props.seedStore(result);
                changePending([]);
                changeTimeoutSet(false);
                changeTimeoutFinished(false);
            });
        }
    }, [pending]);

    const listener = (event: CustomEvent) => {
        if (typeof event.detail == 'string') {
            if (timeoutSet === false) {
                changeTimeoutSet(true);
                setTimeout(() => {
                    changeTimeoutFinished(true);
                }, 1000);
            }
            const stored = localStorage.getItem(STORAGE_KEY);
            if (stored == null) {
                localStorage.setItem(STORAGE_KEY, JSON.stringify([event.detail]));
            } else if (!JSON.parse(stored).includes(event.detail)) {
                localStorage.setItem(STORAGE_KEY, JSON.stringify([...JSON.parse(stored), event.detail]));
            }
        }
    };
}

async function getConstraints(constraintIds: string[]): Promise<Constraint[]> {
    const response = await ConstraintClient.resolveConstraints(constraintIds);
    return response.results;
}
